<template>
    <div>
        <h2>Server Settings</h2>

        <p>Send a notification to all users about server updates:</p>

        <blockquote>
            Please save and exit your work. Trim Designer will be updated.
            <br>
            You have <b>3 minutes</b>.
        </blockquote>

        <br>

        <h3 v-if="canSend"
            class="color-green"
        >Users have been notified!</h3>

        <Button
                v-else
                @click="send"
        >Send</Button>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import Button from "../../../../components/Button";

    export default {
        name: "RestartServerTab",

        components: {
            Button,
        },

        data() {
            return {
                sendStatus: false,
            }
        },

        computed: {
            ...mapState('sockets', [
                'socket',
                'serverOffNoteWasSend',
                'serverWillBeOff',
            ]),

            canSend() {
                return this.serverOffNoteWasSend || this.serverWillBeOff;
            },

        },

        methods: {
            ...mapMutations('sockets', [
                'setServerOffNoteWasSend',
            ]),

            send() {
                // message callback
                this.socket.once('msg-off-server--send', () => {
                    this.setServerOffNoteWasSend(true);
                });

                // send message
                this.socket.emit('msg-off-server');
            },

        }

    }
</script>

<style scoped>
    blockquote {
        margin: 10px 0;
    }
</style>